import {useContext, useState} from 'react'
import {ThemeContext} from "../Context/ThemeContext";

function Home() {
    const Theme = useContext(ThemeContext)
    const [job, setJob] = useState([
        {id: 962658, value: 'aaa', name: 'jjjjjj'},
        {id: 432417, value: 'dfv', name: 'n2222'},
        {id: 531314, value: 'ccc', name: 'rgrerg'},
        {id: 537459, value: 'fff', name: 'ii,ik,'},
        {id: 680140, value: 'eee', name: 'rtgtrb'},
        {id: 334464, value: 'fff', name: 'vfdvr'},
        {id: 877987, value: 'ggg', name: 'btynyhn'},
    ])
    // const sortJob = job.sort((a, b) => a.id - b.id)
    const [user, setUser] = useState('')


    const [editRowId, setEditRowId] = useState(null);
    const [editFormData, setEditFormData] = useState({value: '', name: ''});

    const handleEditClick = (row) => {
        setEditRowId(row.id);
        setEditFormData({name: row.name, value: row.value});
    };

    const handleCancelClick = () => {
        setEditRowId(null);
    };

    const handleChange = (e) => {
        setEditFormData({...editFormData, [e.target.name]: e.target.value});
    };

    const handleSaveClick = (id) => {
        const newData = job.map((item) =>
            item.id === id ? {...item, ...editFormData} : item
        );
        setJob(newData);
        setEditRowId(null);
    };


    function valueuser(event) {
        setUser(event.target.value)


    }

    function adduser() {
        setJob([...job, {id: Math.floor(Math.random() * 1000000), value: user, name: user + 'sdasdas'}])
        setUser('')
    }

    function deleteUser(id) {
        setJob(job.filter((j) => j.id !== id))
    }

  /*  function editUser(id) {
        console.log(id)
    }*/
    return (
        <div >
            <div className="container">
                <div className="row">
                    <div className="col-3">

                        <button className='btn   border border-2' type="button" onClick={()=>Theme.changeTheme(Theme.Theme)}>{Theme.Theme}</button>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label htmlFor='user' className="  col-form-label  ">کد کالا </label>
                            <div className=" ">
                                <input type="text" id='user' value={user} className="form-control"
                                       onChange={(event) => valueuser(event)}></input>
                            </div>
                        </div>
                        {user == null ? 'nnnnnn' : 'nonulll'}
                        <button type="button" disabled={user === '' ? true : false}
                                className="btn btn-success mx-2 px-4 py-2" onClick={adduser}>افزودن
                        </button>
                    </div>
                </div>

                <div className="row">
                    {/* <div className="col-3">
                      {job.map((j, index) => {
                          return <h1 key={index}>{j.name}</h1>
                      })}
                  </div>*/}
                </div>


                <div className="row my-5">
                    <table className="table  table-hover table-bordered table-responsive-lg">
                        <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">name</th>
                            <th scope="col">value</th>
                            {/*  <th scope="col">نام</th>
                            <th scope="col">نام خانوادگی</th>*/}
                            <th scope="col"> Edit/Delete</th>


                        </tr>
                        </thead>
                        <tbody>
                        {job.map((row) => (
                            <tr key={row.id}>
                                <td>

                                    {row.id}

                                </td>
                                <td>
                                    {editRowId === row.id ? (
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            value={editFormData.name}
                                            onChange={handleChange}
                                        />
                                    ) : (
                                        row.name
                                    )}
                                </td>
                                <td>
                                    {editRowId === row.id ? (
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="value"
                                            value={editFormData.value}
                                            onChange={handleChange}
                                        />
                                    ) : (
                                        row.value
                                    )}
                                </td>
                                <td>
                                    {editRowId === row.id ? (
                                        <>
                                            <button className="btn btn-success      "
                                                    onClick={() => handleSaveClick(row.id)}>Save
                                            </button>
                                            <button className="btn btn-warning      "
                                                    onClick={handleCancelClick}>Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="btn btn-info    mx-2  "
                                                    onClick={() => handleEditClick(row)}>Edit
                                            </button>
                                            <button className="btn btn-danger "
                                                    onClick={() => deleteUser(row.id)}>Delete
                                            </button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Home

